import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { type ContactCreateModalStore } from 'widgets/ContactCreateModal'
import { ContactsDetails } from 'widgets/ContactsDetails'
import styles from './styles.module.scss'

type IContactCreateModalContentProps = {
  contactCreateModalStore: ContactCreateModalStore
}

export const ContactCreateModalContent: FC<IContactCreateModalContentProps> = observer(
  ({ contactCreateModalStore }) => {
    const isLoading = contactCreateModalStore.isLoading
    const contactsDetailsStore = contactCreateModalStore.contactsDetailsStore

    if (isLoading) return <SpinnerLoader ariaLabel={'ContactCreateModalContent'} />

    return (
      <div className={styles.wrap}>
        {contactsDetailsStore && <ContactsDetails store={contactsDetailsStore} />}
      </div>
    )
  }
)
